import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useSetUpUI } from '../../context'
import { CONFIG_SETUP_ROUTES } from '../../routes'
import useSetupUrlInterfaceId from '../../hooks/setup/useSetupUrlInterfaceId'

const ReviewDecodersView = () => {
  const { closeModal } = useSetUpUI()
  // SCRUM-976: pin to URL :id, not the global selected interface (AuthContext/localStorage).
  // This modal is rendered as a sibling of <Routes> (via ModalUI), not as a descendant of
  // the matched discovery/:id route, so useParams() here would always be undefined.
  const id = useSetupUrlInterfaceId()

  const navigate = useNavigate()

  const handleNext = () => {
    closeModal()
    navigate(CONFIG_SETUP_ROUTES.setupFirst.to(id || ''))
  }
  return (
    <Stack
      sx={{
        backgroundColor: 'background.default',
        minWidth: '378px',
        minHeight: '150px',
        padding: '32px 40px',
      }}
    >
      <Stack flexGrow="1" height="100%">
        <Typography sx={{ fontSize: '20px', lineHeight: '1.6' }}>
          There's a configuration or decoder purpose that hasn't been saved.
          Would you still want to continue?
        </Typography>
        <Stack
          direction="row"
          spacing={2}
          sx={{ justifyContent: 'end', mt: '30px' }}
        >
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="small"
            type="submit"
            onClick={handleNext}
          >
            Continue
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ReviewDecodersView
